import React from "react"
import { FaIcon } from '../common/Icons.jsx';

export default function NavbarBadge({unreadCount, activePulse, loaded}) {
  return <a href="#" className="dropdown-toggle" data-toggle="dropdown">
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', height: '40px'}}>
      <FaIcon type='clock-o' /> 
      <span 
        className={`label ${unreadCount > 0 ? 'label-warning' : 'label-default'} ${activePulse ? 'animation-pop' : ''}`} 
        style={{minWidth: '20px'}}
      >
        {loaded ? unreadCount : <span>&nbsp;</span>}
      </span>
    </div>
  </a>
}
